import { Routes, Route } from "react-router-dom";

import MerchantListScreen from "screens/App/CRM/Merchant/MerchantListScreen";
// import MerchantInfoScreen from "screens/App/CRM/Merchant/MerchantInfoScreen";
import MerchantDetailScreen from "screens/App/CRM/Merchant/MerchantDetailScreen";
import MerchantEditScreen from "screens/App/CRM/Merchant/MerchantEditScreen";
import MerchantCreateScreen from "screens/App/CRM/Merchant/MerchantCreateScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const MerchantRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<MerchantListScreen />} />
      <Route path="create" element={<MerchantCreateScreen />} />
      <Route path=":id/detail" element={<MerchantDetailScreen />} />
      <Route path=":id/edit" element={<MerchantEditScreen />} />
      {/* <Route path="info" element={<MerchantInfoScreen />} /> */}
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default MerchantRouter;